/**
 * PATH: packages/email-hub/src/feature/components/filter-sidebar/TagsSection.tsx
 * FILE_ID: EMAILHUB-FILTERSIDEBAR-TAGS-001
 * PURPOSE: Renders the read-only email tag facet section.
 */
import { SectionHeader } from './SidebarChrome'
import type { SectionProps } from './types'

interface TagsSectionProps extends SectionProps {
  tags: Array<{ id: number; name: string; color: string }>
}

export function TagsSection({
  expanded,
  onToggle,
  tags,
}: TagsSectionProps) {
  return (
    <div>
      <SectionHeader label="Tags" expanded={expanded} onToggle={onToggle} />
      {expanded && (
        <div className="space-y-0.5">
          {tags.length === 0 ? (
            <p className="text-[10px] text-muted-foreground px-2">No tags yet</p>
          ) : (
            tags.map((tag) => (
              <div
                key={tag.id}
                className="flex items-center gap-1.5 px-2 py-1 text-xs text-muted-foreground"
              >
                <span
                  className="h-2 w-2 rounded-full shrink-0"
                  style={{ backgroundColor: tag.color }}
                />
                {tag.name}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}
